module.exports = __webpack_public_path__ + "img/reference69.c36fd2eb.jpg";